import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUserFill = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.4326 14.031C14.3887 14.107 14.3256 14.1702 14.2496 14.214C14.1735 14.2579 14.0873 14.281 13.9995 14.281H1.99949C1.91176 14.2809 1.82561 14.2577 1.74967 14.2138C1.67373 14.1699 1.61068 14.1068 1.56686 14.0308C1.52304 13.9548 1.49998 13.8686 1.5 13.7809C1.50002 13.6931 1.52312 13.607 1.56699 13.531C2.51886 11.8854 3.98574 10.7054 5.69761 10.146C4.85084 9.64191 4.19295 8.8738 3.82498 7.95962C3.457 7.04544 3.39929 6.03575 3.6607 5.0856C3.92211 4.13544 4.48819 3.29737 5.272 2.70008C6.05582 2.10278 7.01403 1.7793 7.99949 1.7793C8.98494 1.7793 9.94316 2.10278 10.727 2.70008C11.5108 3.29737 12.0769 4.13544 12.3383 5.0856C12.5997 6.03575 12.542 7.04544 12.174 7.95962C11.806 8.8738 11.1481 9.64191 10.3014 10.146C12.0132 10.7054 13.4801 11.8854 14.432 13.531C14.476 13.607 14.4992 13.6931 14.4993 13.7809C14.4994 13.8687 14.4764 13.9549 14.4326 14.031Z",
		fill: "#90A4AE"
	})
});
export default SvgUserFill;
